import { useState, useCallback } from 'react';

// ----------------------------------------------------------------------

// Định nghĩa kiểu cho Solana (Phantom)
type PhantomEvent = 'connect' | 'disconnect' | 'accountChanged';

interface PhantomProvider {
  isPhantom?: boolean;
  // onlyIfTrusted: true giúp không hiện popup nếu đã từng connect trước đó
  connect: (opts?: { onlyIfTrusted?: boolean }) => Promise<{ publicKey: { toString: () => string } }>;
  disconnect: () => Promise<void>;
  on: (event: PhantomEvent, handler: (args: any) => void) => void;
  request: (method: any) => Promise<any>;
}

declare global {
  interface Window {
    solana?: PhantomProvider;
  }
}

export function useConnectDevnet() {
  const [walletAddress, setWalletAddress] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const connect = useCallback(async () => {
    setLoading(true);
    setErrorMsg('');
    setWalletAddress('');

    const { solana } = window;

    if (!solana || !solana.isPhantom) {
      setErrorMsg('Không tìm thấy ví Phantom! Vui lòng cài Extension.');
      setLoading(false);
      return;
    }

    try {
      const response = await solana.connect();
      
      const address = response.publicKey.toString();
      
      setWalletAddress(address);
      console.log('Connected to Solana Wallet:', address);

    } catch (error: any) {
      console.error('Solana connect error:', error);
      if (error.code === 4001) {
        setErrorMsg('Bạn đã từ chối kết nối.');
      } else {
        setErrorMsg(error.message || 'Lỗi kết nối.');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const disconnect = useCallback(async () => {
    const { solana } = window;
    if (solana) {
      try {
        await solana.disconnect();
        setWalletAddress('');
      } catch (err) {
        console.error(err);
      }
    }
  }, []); 

  return {
    walletAddress,
    errorMsg,
    loading,
    connect,
    disconnect,
    isConnected: !!walletAddress,
  };
}